import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-terminos',
  templateUrl: './terminos.page.html',
  styleUrls: ['./terminos.page.scss' , '../../assets/scss/styles.scss'],
})
export class TerminosPage implements OnInit {

  isMobile:boolean;

  constructor(
    public services:ServiceService,
    private _location: Location
  ) { }

  ngOnInit() {
    this.isMobile = this.services.isMovil();
  }

  backClicked() {
    this._location.back();
  }

}
